import * as React from 'react';
import './calendarDashboard.less';
import Flipper from '../components/flipper/flipper';
import { Dashboard } from './dashboard/dashboard';
import MessagingTopics from '../../../common/messaging/messagingTopics';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useDataStream } from '../hooks/useDataStream';
import { HappinessCalendar } from './calendar/happinessCalendar';
import { Button, ButtonGroup } from '@mui/material';
import * as moment from 'moment';
import { setDisplayedDate, setDisplayedYear, setSelectedView } from '../../store/calendar';
import { DateFormat } from '../../../common/utils/dateUtils';
import { useCallback } from 'react';

export function CalendarDashboard() {
  const { entries, selectedView, displayedDate } = useSelector((state: RootState) => state.calendar);
  const username = useSelector((state: RootState) => state.login.username);
  const dispatch = useDispatch();

  useDataStream(MessagingTopics.RegisterHappinessStream);

  const getCalendarViewButtonProps = useCallback((option: 'monthly' | 'yearly') => ({
    variant: 'contained' as const,
    color: (selectedView === option ? 'secondary' : 'primary') as 'primary' | 'secondary'
  }), [selectedView]);

  const getTodayButtonProps = useCallback(() => ({
    variant: 'contained' as const,
    color: moment(displayedDate).format(DateFormat.LEGACY_MOMENT_SHORT_ISO) ===
      moment.utc().format(DateFormat.LEGACY_MOMENT_SHORT_ISO) ? 'secondary' : 'primary' as 'primary' | 'secondary'
  }), [displayedDate]);

  const handleDisplayedDateChange = (moment: moment.Moment) =>
    dispatch(
      setDisplayedDate(moment.format(DateFormat.LEGACY_MOMENT_SHORT_ISO))
    );
  const handleDisplayedYearChange = (year: number) =>
    dispatch(setDisplayedYear(year));

  const handleTodayClicked = useCallback(() => {
    const now = moment().utc().startOf('day');
    handleDisplayedDateChange(now);
    handleDisplayedYearChange(now.year());
  }, [handleDisplayedDateChange, handleDisplayedYearChange]);

  if (!entries.length) {
    return null;
  }

  const handleClickMonthly = () => dispatch(setSelectedView('monthly'));
  const handleClickYearly = () => dispatch(setSelectedView('yearly'));

  const frontContent = (
    <div className="jlj-happiness">
      <div className='viewButtonGroup'>
        <Button
          {...getTodayButtonProps()}
          onClick={handleTodayClicked}
        >
          Today
        </Button>
        <ButtonGroup size='small'>
          <Button
            {...getCalendarViewButtonProps('monthly')}
            onClick={handleClickMonthly}
          >
            Monthly
          </Button>
          <Button
            {...getCalendarViewButtonProps('yearly')}
            onClick={handleClickYearly}
          >
            Yearly
          </Button>
        </ButtonGroup>
      </div>

      <div className={selectedView + 'View'}>
        <HappinessCalendar username={username}
                           view={selectedView}
                           handleDisplayedDateChange={handleDisplayedDateChange}
                           handleDisplayedYearChange={handleDisplayedYearChange}
        />
      </div>
      <div className={'jlj-happiness__other-person ' + selectedView + 'View'}>
        <HappinessCalendar username={username === 'ana' ? 'pedro' : 'ana'}
                           view={selectedView}
                           handleDisplayedDateChange={handleDisplayedDateChange}
                           handleDisplayedYearChange={handleDisplayedYearChange}
        />
      </div>
    </div>
  );

  const backContent = <Dashboard />;

  return <Flipper frontContent={frontContent} backContent={backContent} />;
}
